module.exports = __webpack_public_path__ + "media/images/Switzerland-0b55a039667d42e9675c5f05b34a2ee3.png";